module.exports = __webpack_public_path__ + "assets/img/yutari.5c35e017.svg";